var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',{ref:"logisticMapElement",attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.mapOptions}},[_c('l-tile-layer',{attrs:{"url":_vm.urlMap}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }